// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetResponse

import { WidgetFlow } from './enums.gen';
import { hydrateWidgetTheme, type WidgetTheme, type WidgetThemeApiResponse } from './widgetTheme.gen';
import { hydrateWidgetCustomContent, type WidgetCustomContent, type WidgetCustomContentApiResponse } from './widgetCustomContent.gen';
import { hydrateWidgetMemberArea, type WidgetMemberArea, type WidgetMemberAreaApiResponse } from './widgetMemberArea.gen';
import { hydrateWidgetEmailSettings, type WidgetEmailSettings, type WidgetEmailSettingsApiResponse } from './widgetEmailSettings.gen';
import { hydrateWidgetContact, type WidgetContact, type WidgetContactApiResponse } from './widgetContact.gen';
import { hydrateWidgetSmsSettings, type WidgetSmsSettings, type WidgetSmsSettingsApiResponse } from './widgetSmsSettings.gen';
import { hydrateWidgetGoogleReserve, type WidgetGoogleReserve, type WidgetGoogleReserveApiResponse } from './widgetGoogleReserve.gen';

export type WidgetApiResponse = {
	id: number;
	name: string | null;
	businessName: string | null;
	hash: string;
	url: string;
	logo: string | null;
	hasBanner: boolean;
	theme: WidgetThemeApiResponse;
	isActive: boolean;
	isDefault: boolean;
	termsLink: string | null;
	termsContent: string | null;
	customContent: WidgetCustomContentApiResponse;
	flowSelected: WidgetFlow;
	paymentEnabled: boolean;
	showCustomerRequestInput: boolean;
	showCollectionInGrid: boolean;
	googleTagManagerId: string;
	isWhitelabel: boolean;
	maxFutureBookingDays: number | null;
	memberArea: WidgetMemberAreaApiResponse;
	email: WidgetEmailSettingsApiResponse;
	contact: WidgetContactApiResponse;
	sms: WidgetSmsSettingsApiResponse;
	offers: Array<string> | null;
	bookableGiftcards: Array<string> | null;
	packages: Array<string> | null;
	googleReserve: WidgetGoogleReserveApiResponse | null;
};

export type Widget = {
	id: number;
	name: string | null;
	businessName: string | null;
	hash: string;
	url: string;
	logo: string | null;
	hasBanner: boolean;
	theme: WidgetTheme;
	isActive: boolean;
	isDefault: boolean;
	termsLink: string | null;
	termsContent: string | null;
	customContent: WidgetCustomContent;
	flowSelected: WidgetFlow;
	paymentEnabled: boolean;
	showCustomerRequestInput: boolean;
	showCollectionInGrid: boolean;
	googleTagManagerId: string;
	isWhitelabel: boolean;
	maxFutureBookingDays: number | null;
	memberArea: WidgetMemberArea;
	email: WidgetEmailSettings;
	contact: WidgetContact;
	sms: WidgetSmsSettings;
	offers: Array<string> | null;
	bookableGiftcards: Array<string> | null;
	packages: Array<string> | null;
	googleReserve: WidgetGoogleReserve | null;
};

export function hydrateWidget(data: WidgetApiResponse): Widget {
	return {
		...data,
		theme: hydrateWidgetTheme(data.theme),
		customContent: hydrateWidgetCustomContent(data.customContent),
		memberArea: hydrateWidgetMemberArea(data.memberArea),
		email: hydrateWidgetEmailSettings(data.email),
		contact: hydrateWidgetContact(data.contact),
		sms: hydrateWidgetSmsSettings(data.sms),
		googleReserve: data.googleReserve ? hydrateWidgetGoogleReserve(data.googleReserve) : null,
	};
}